import { CSSProperties } from 'react';

import { ProgressCircle } from '../../../../content/progress/ProgressCircle.js';
import { loaderOverlay, progressCircle } from './LoaderOverlay.sty.js';

export const LoaderOverlay = ({
  gridArea,
  consumerStyle,
}: {
  gridArea?: string;
  consumerStyle?: CSSProperties;
}) => (
  <>
    {/* Applies a transparent layer to the whole layout */}
    <div className={loaderOverlay} style={consumerStyle} />
    {/* Show the progress circle centered on `gridArea` */}
    <div className={progressCircle} style={{ gridArea }}>
      <ProgressCircle size="large" data-testid="progress-circle" />
    </div>
  </>
);

LoaderOverlay['displayName'] = 'LoaderOverlay';
